import React from "react";
import styles from "./Modal.module.scss";

interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  message: string;
  isError?: boolean;
}

const Modal: React.FC<ModalProps> = ({ isOpen, onClose, message, isError = false }) => {
  if (!isOpen) return null;

  return (
    <div className={styles.modalOverlay}>
      <div className={styles.modal}>
        <h2 className={styles.modalTitle}>{isError ? "Error" : "Success"}</h2>
        <p className={`${styles.modalMessage} ${isError ? styles.error : ''}`}>{message}</p>
        <button className={styles.modalButton} onClick={onClose}>
          Close
        </button>
      </div>
    </div>
  );
};

export default Modal;